import type {
  ScheduleSnapshotDetail,
  ScheduleSnapshotSummary,
  ScheduleTaskStatus
} from '@/types'

export function sortSnapshotsNewestFirst(
  snapshotList: ScheduleSnapshotSummary[]
): ScheduleSnapshotSummary[] {
  return [...snapshotList].sort((left, right) => {
    const rightTime = Date.parse(right.updatedAt ?? right.createdAt ?? '') || 0
    const leftTime = Date.parse(left.updatedAt ?? left.createdAt ?? '') || 0
    return rightTime - leftTime
  })
}

export function pickDefaultSnapshot(
  snapshotList: ScheduleSnapshotSummary[],
  preferLatestGenerated = false
): ScheduleSnapshotSummary | null {
  const sorted = sortSnapshotsNewestFirst(snapshotList)
  if (sorted.length === 0) {
    return null
  }
  if (preferLatestGenerated) {
    return sorted.find((item) => item.snapshotType === 'GENERATED') ?? sorted[0]
  }
  return sorted[0]
}

export function findPublishedSnapshotId(
  snapshots: ScheduleSnapshotSummary[]
): number | null {
  const published = snapshots.find(
    (snapshot) =>
      snapshot.isPublished === true
      || snapshot.snapshotStatus === 'SNAPSHOT_PUBLISHED'
      || snapshot.snapshotStatus === 'SNAPSHOT_ACTIVATED'
  )
  return published?.id ?? null
}

export function applySnapshotStatusToList(
  snapshots: ScheduleSnapshotSummary[],
  status: ScheduleTaskStatus,
  publishedSnapshotId: number | null
): ScheduleSnapshotSummary[] {
  return snapshots.map((snapshot) => {
    const isCurrentPublished = publishedSnapshotId != null && snapshot.id === publishedSnapshotId
    return {
      ...snapshot,
      isPublished: isCurrentPublished,
      snapshotStatus: isCurrentPublished
        ? (status === 'TASK_ACTIVATED' ? 'SNAPSHOT_ACTIVATED' : 'SNAPSHOT_PUBLISHED')
        : 'SNAPSHOT_UNPUBLISHED'
    }
  })
}

export function applySnapshotStatusToDetail(
  activeSnapshot: ScheduleSnapshotDetail,
  status: ScheduleTaskStatus,
  publishedSnapshotId: number | null
): ScheduleSnapshotDetail {
  const isCurrentPublished =
    publishedSnapshotId != null && activeSnapshot.id === publishedSnapshotId
  return {
    ...activeSnapshot,
    isPublished: isCurrentPublished,
    snapshotStatus: isCurrentPublished
      ? (status === 'TASK_ACTIVATED' ? 'SNAPSHOT_ACTIVATED' : 'SNAPSHOT_PUBLISHED')
      : 'SNAPSHOT_UNPUBLISHED'
  }
}
